import { usePathname } from 'expo-router'

import { getPageTypeConfig, resolvePageType } from '@/src/general/constants/pageTypes'

export const usePageType = () => {
  const pathname = usePathname()
  const type = resolvePageType(pathname)

  return { type, ...getPageTypeConfig(pathname) }
}
